import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=990a08f8&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=js&"
export * from "./Switcher.vue?vue&type=script&lang=js&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=990a08f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990a08f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('990a08f8')) {
      api.createRecord('990a08f8', component.options)
    } else {
      api.reload('990a08f8', component.options)
    }
    module.hot.accept("./Switcher.vue?vue&type=template&id=990a08f8&scoped=true&", function () {
      api.rerender('990a08f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls2/Switcher.vue"
export default component.exports